import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=f4597e6c&scoped=true"
import script from "./DangerZone.vue?vue&type=script&setup=true&lang=js"
export * from "./DangerZone.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4597e6c",
  null
  
)

export default component.exports